<ng-container [formGroup]="form">
	<div class="flex md:flex-row md:space-x-3 md:space-y-0 flex-col space-y-3">
		<div class="flex-1 md:space-y-0 space-y-1 flex flex-col">
			<label
				[title]="controller.baseI18n + '.name.label' | translate"
				class="md:hidden"
			>
				{{ controller.baseI18n + '.name.label' | translate }}
			</label>
			<input
				[placeholder]="controller.baseI18n + '.name.placeHolder' | translate"
				class="w-full"
				formControlName="name"
				pInputText
				type="text"
			/>
		</div>
		<div class="flex-1 md:space-y-0 space-y-1 flex flex-col">
			<label
				[title]="controller.baseI18n + '.institution.label' | translate"
				class="md:hidden"
			>
				{{ controller.baseI18n + '.institution.label' | translate }}
			</label>
			<input
				[placeholder]="controller.baseI18n + '.institution.placeHolder' | translate"
				class="w-full"
				formControlName="institution"
				pInputText
				type="text"
			/>
		</div>
		<div
			*ngIf="controller.calendarLocale$ | async; let calendarLocale"
			class="flex-1 md:space-y-0 space-y-1 flex flex-col"
		>
			<label
				[title]="controller.baseI18n + '.dates.label' | translate"
				class="md:hidden"
			>
				{{ controller.baseI18n + '.dates.label' | translate }}
			</label>
			<p-calendar
				[inputStyle]="{ width: '100%' }"
				[locale]="calendarLocale"
				[monthNavigator]="true"
				[placeholder]="controller.baseI18n + '.dates.placeHolder' | translate"
				[readonlyInput]="true"
				[style]="{ width: '100%' }"
				[yearNavigator]="true"
				[yearRange]="referenceDateRange"
				appendTo="body"
				formControlName="range"
				selectionMode="range"
			></p-calendar>
		</div>
		<div class="md:flex-none md:w-16 flex md:items-center justify-end">
			<ng-content></ng-content>
		</div>
	</div>
</ng-container>
